import { Form, FormInstance, Input, Row, Select } from "antd";

import { General } from "../../../../util/General";
import FormInputRules from "../../../../util/FormInputRules";
import { useKeyFobAllocation } from "./index.hook.ts";
import { formItemLayout, inputLayout2 } from "../../../../constants/ApplicationConstants/FormConstants";

interface KeyFobAllocationProps {
  form: FormInstance<any>;
  advance_booking_request_id: number;
  vehicle_type_id: number;
  booking_id: string;
}

const KeyFobAllocation = (props: KeyFobAllocationProps) => {
  const config = useKeyFobAllocation(props);

  const inputLayout = {
    ...inputLayout2,
    labelCol: { ...formItemLayout.labelCol, lg: { span: 9 } }
  };

  return (
    <>
      <h4 style={{ fontWeight: "bolder" }}>Raise Booking Request</h4>
      <div style={{ margin: "2rem 0rem", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
        <Row style={{ gap: "2rem" }}>
          <Form.Item {...inputLayout} name="booking_id" label="ABR ID" required>
            <Input name="booking_id" disabled />
          </Form.Item>

          <Form.Item {...inputLayout} name="key_fob_id" label="KeyFob Token" rules={[FormInputRules.requiredFieldSelectRule("key fob token")]}>
            <Select showSearch listHeight={200} allowClear getPopupContainer={(trigger) => trigger.parentElement} filterOption={General.searchFilterOnSelect} placeholder="Select KeyFob token" style={{ width: "200px" }}>
              {config.keyFobList?.map((item: any) => (
                <Select.Option key={item.id} value={item.id}>
                  {item?.keyFob_vehicle_dimension}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item {...inputLayout} name="vehicle_number" label="Vehicle Number" normalize={General.inputWhiteSpaceRemove} rules={[FormInputRules.requiredFieldInputRule("vehicle number"), FormInputRules.validateVehicleNumber]}>
            <Input name="vehicle_number" />
          </Form.Item>
        </Row>
      </div>
    </>
  );
};

export default KeyFobAllocation;
